import { createContext } from 'react'

import { AddEditDomainContextType } from './types'

export const AddEditDomainContext = createContext<AddEditDomainContextType>(
  {} as AddEditDomainContextType,
)
